import config from '@config';
import {
  initializeHttp,
  setupCookieUnauthorizedInterceptorFabric,
  setupCsrfInterceptor,
  setupOrganizationSessionInterceptor,
  setupRequestInterceptor,
  setupServerErrorInterceptor,
} from '@gasbi/shared';

const instance = initializeHttp(config.VITE_API_URL, [
  setupRequestInterceptor,
  setupCsrfInterceptor,
  // Cookie session (GSB-8274): a 403 `organization_unavailable` reads the session's organization again.
  setupOrganizationSessionInterceptor,
  setupCookieUnauthorizedInterceptorFabric('/api/login'),
  setupServerErrorInterceptor,
]);

export default instance;
